import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'card-component',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
    @Input() headerTitle: string;

    @Input() collapsable: boolean = false;
    @Input() collapsed: boolean = false;
    constructor(
    ) {
    }

    ngOnInit(): void {
    }

    toggleCollapse(): void {
        if (!this.collapsable) {
            return;
        }
        this.collapsed = !this.collapsed;
    }

}
